import { render } from "./CreateNetwork.vue?vue&type=template&id=138ad6e5&scoped=true"
import script from "./CreateNetwork.vue?vue&type=script&lang=js"
export * from "./CreateNetwork.vue?vue&type=script&lang=js"

import "./CreateNetwork.vue?vue&type=style&index=0&id=138ad6e5&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138ad6e5"]])

export default __exports__